import { Box, MenuItem, Select } from '@mui/material';
import React from 'react';

const RolesListSelectorBase = ({ disabled = false, selected_roles = [], change_handler = (event) => { }, }) => {
  return (
    <Box className="w-full p-2">
      <Select
        disabled={disabled} // Disable for current user
        className="w-full"
        multiple
        size="small"
        value={selected_roles}
        onChange={change_handler}
        name='roles_list'
      >
        <MenuItem value="sample_receiver">Sample Receiver</MenuItem>
        <MenuItem value="sample_collector">Sample Collector</MenuItem>
        <MenuItem value="production_team">Production Team</MenuItem>
        <MenuItem value="analyst">Analyst</MenuItem>
        <MenuItem value="planner">Planner</MenuItem>
        <MenuItem value="reviewer">Reviewer</MenuItem>
        <MenuItem value="approver">Approver</MenuItem>
        <MenuItem value="ud">UD</MenuItem>
        <MenuItem value="admin">Admin</MenuItem>
      </Select>
    </Box>
  );
};

export default RolesListSelectorBase;